import { RatingOption } from "@/types/community"

export const RATING_OPTIONS: RatingOption[] = [
  { value: 5, label: "Mindblowing", emoji: "🤯" },
  { value: 4, label: "Awesome", emoji: "👏" },
  { value: 3, label: "Good", emoji: "👍" },
  { value: 2, label: "It’s okay", emoji: "😐" },
  { value: 1, label: "Not great", emoji: "😞" },
]

export const REMOVED_REVIEW_MESSAGE =
  "This review can’t be published. It violates our content rules. If you think this is a mistake, contact support."
